import { DonhangsanphamService } from 'src/services/donhangsanpham.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const DONHANGSANPHAM_NEW_CARE_SUCCESS = 'DONHANGSANPHAM:NEW_CARE_SUCCESS'
export const DONHANGSANPHAM_LIST_SUCCESS = 'DONHANGSANPHAM:FIND_ALL_SUCCESS'
export const DONHANGSANPHAM_LIST_FAILD = 'DONHANGSANPHAM:FIND_ALL_FAILD'
export const DONHANGSANPHAM_COUNT_ASSIGN_SUCCESS = 'DONHANGSANPHAM:COUNT_ASSIGN_SUCCESS'
export const DONHANGSANPHAM_COUNT_ASSIGN_FAILD = 'DONHANGSANPHAM:COUNT_ASSIGN_FAILD'

export const DONHANGSANPHAM_CREATE_SUCCESS = 'DONHANGSANPHAM:CREATE_SUCCESS'
export const DONHANGSANPHAM_CREATE_FAILD = 'DONHANGSANPHAM:CREATE_FAILD'

export const DONHANGSANPHAM_IMPORT_SUCCESS = 'DONHANGSANPHAM:IMPORT_SUCCESS'
export const DONHANGSANPHAM_SAVE_SUCCESS = 'DONHANGSANPHAM:SAVE_SUCCESS'
export const DONHANGSANPHAM_SAVE_FAILD = 'DONHANGSANPHAM:SAVE_SUCCESS'

export const DONHANGSANPHAM_DEL_SUCCESS = 'DONHANGSANPHAM:DEL_SUCCESS'
export const DONHANGSANPHAM_DEL_FAILD = 'DONHANGSANPHAM:DEL_FAILD'

export const DONHANGSANPHAM_ONE_SUCCESS = 'DONHANGSANPHAM:FIND_ONE_SUCCESS'
export const DONHANGSANPHAM_ONE_FAILD = 'DONHANGSANPHAM:FIND_ONE_FAILD'

export const DONHANGSANPHAM_HISTORY_LIST_SUCCESS = 'DONHANGSANPHAM:HISTORY_FIND_ALL_SUCCESS'
export const DONHANGSANPHAM_HISTORY_LIST_FAILD = 'DONHANGSANPHAM:HISTORY_FIND_ALL_FAILD'

export const DONHANGSANPHAM_UPDATE_FILTER = 'DONHANGSANPHAM:DONHANGSANPHAM_UPDATE_FILTER'

export const DONHANGSANPHAM_LIST_EXPORT_SUCCESS = 'DONHANGSANPHAM:FIND_ALL_EXPORT_SUCCESS'
export const DONHANGSANPHAM_LIST_EXPORT_FAILD = 'DONHANGSANPHAM:FIND_ALL_EXPORT_FAILD'

export const DONHANGSANPHAM_DONHANGSANPHAM_SUCCESS = 'DONHANGSANPHAM:DONHANGSANPHAM_SUCCESS'
export const DONHANGSANPHAM_DONHANGSANPHAM_FAILD = 'DONHANGSANPHAM:DONHANGSANPHAM_FAILD'

export const DONHANGSANPHAM_UPDATE_HOMEPAGE_FILTER = 'DONHANGSANPHAM:DONHANGSANPHAM_UPDATE_HOMEPAGE_FILTER'

export const DONHANGSANPHAM_HOMEPAGE_LIST_SUCCESS = 'DONHANGSANPHAM:FIND_HOMEPAGE_LIST_SUCCESS'
export const DONHANGSANPHAM_HOMEPAGE_LIST_FAILD = 'DONHANGSANPHAM:FIND_HOMEPAGE_LIST_FAILD'

export const DONHANGSANPHAM_HOMEPAGE_ONE_SUCCESS = 'DONHANGSANPHAM:FIND_HOMEPAGE_ONE_SUCCESS'
export const DONHANGSANPHAM_HOMEPAGE_ONE_FAILD = 'DONHANGSANPHAM:FIND_HOMEPAGE_ONE_FAILD'

export const DONHANGSANPHAM_LIMIT_UPDATE_HOMEPAGE_FILTER = 'DONHANGSANPHAM:DONHANGSANPHAM_LIMIT_UPDATE_HOMEPAGE_FILTER'

export const DONHANGSANPHAM_LIMIT_HOMEPAGE_LIST_SUCCESS = 'DONHANGSANPHAM:LIMIT_FIND_HOMEPAGE_LIST_SUCCESS'
export const DONHANGSANPHAM_LIMIT_HOMEPAGE_LIST_FAILD = 'DONHANGSANPHAM:LIMIT_FIND_HOMEPAGE_LIST_FAILD'

export const DONHANGSANPHAM_LIMIT_HOMEPAGE_ONE_SUCCESS = 'DONHANGSANPHAM:LIMIT_FIND_HOMEPAGE_ONE_SUCCESS'
export const DONHANGSANPHAM_LIMIT_HOMEPAGE_ONE_FAILD = 'DONHANGSANPHAM:LIMIT_FIND_HOMEPAGE_ONE_FAILD'

export const DONHANGSANPHAM_HANDLE_IMPORT_ERRORS = 'DONHANGSANPHAM:DONHANGSANPHAM_HANDLE_IMPORT_ERRORS'

export const DonhangsanphamAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    updateFilter,
    saveDataUpload,
    findPackage,
    listExport,
    listNoLimit,
    homepageList,
    updateHomepageFilter,
    homepageFindOne,
    homepageLimitList,
    updateHomepageLimitFilter,
    homepageLimitFindOne,
    sendDonhangsanpham,
}

function updateHomepageFilter(payload) {
    return { type: DONHANGSANPHAM_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageList() {
    return (dispatch, getState) => {
        const { donhangsanpham } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageDonhangsanphamFilter } = donhangsanpham;
        const homepageDonhangsanphamPage = homepageDonhangsanphamFilter.homepageDonhangsanphamPage;
        const homepageDonhangsanphamLimit = homepageDonhangsanphamFilter.homepageDonhangsanphamLimit;

        return new Promise((resolve, reject) => {
            DonhangsanphamService.homepageList(homepageDonhangsanphamFilter).then((rs) => {
                if (!!homepageDonhangsanphamFilter && homepageDonhangsanphamFilter.homepageDonhangsanphamPage === 0) {
                    dispatch(success({
                        homepageDonhangsanphamItems: rs.data.values,
                        homepageDonhangsanphamTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = donhangsanpham.homepageDonhangsanphamItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageDonhangsanphamLimit * homepageDonhangsanphamPage; i < homepageDonhangsanphamLimit * homepageDonhangsanphamPage + homepageDonhangsanphamLimit; i++) {
                        if (typeof rsDataValues[i - homepageDonhangsanphamLimit * homepageDonhangsanphamPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageDonhangsanphamLimit * homepageDonhangsanphamPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageDonhangsanphamItems: uniqueItems,
                        homepageDonhangsanphamTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: DONHANGSANPHAM_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: DONHANGSANPHAM_HOMEPAGE_LIST_FAILD, error } }
}

function homepageFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        DonhangsanphamService.homepageFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: DONHANGSANPHAM_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: DONHANGSANPHAM_HOMEPAGE_ONE_FAILD, error } }
}

function updateHomepageLimitFilter(payload) {
    return { type: DONHANGSANPHAM_LIMIT_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageLimitList() {
    return (dispatch, getState) => {
        const { donhangsanpham } = getState();
        // dispatch(AppAction.appLoading(true));

        const { homepageDonhangsanphamLimitFilter } = donhangsanpham;
        const homepageDonhangsanphamLimitPage = homepageDonhangsanphamLimitFilter.homepageDonhangsanphamLimitPage;
        const homepageDonhangsanphamLimitLimit = homepageDonhangsanphamLimitFilter.homepageDonhangsanphamLimitLimit;

        return new Promise((resolve, reject) => {
            DonhangsanphamService.homepageLimitList(homepageDonhangsanphamLimitFilter).then((rs) => {
                if (!!homepageDonhangsanphamLimitFilter && homepageDonhangsanphamLimitFilter.homepageDonhangsanphamLimitPage === 0) {
                    dispatch(success({
                        homepageDonhangsanphamLimitItems: rs.data.values,
                        homepageDonhangsanphamLimitTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = donhangsanpham.homepageDonhangsanphamLimitItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageDonhangsanphamLimitLimit * homepageDonhangsanphamLimitPage; i < homepageDonhangsanphamLimitLimit * homepageDonhangsanphamLimitPage + homepageDonhangsanphamLimitLimit; i++) {
                        if (typeof rsDataValues[i - homepageDonhangsanphamLimitLimit * homepageDonhangsanphamLimitPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageDonhangsanphamLimitLimit * homepageDonhangsanphamLimitPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageDonhangsanphamLimitItems: uniqueItems,
                        homepageDonhangsanphamLimitTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                // dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: DONHANGSANPHAM_LIMIT_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: DONHANGSANPHAM_LIMIT_HOMEPAGE_LIST_FAILD, error } }
}

function homepageLimitFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        DonhangsanphamService.homepageLimitFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: DONHANGSANPHAM_LIMIT_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: DONHANGSANPHAM_LIMIT_HOMEPAGE_ONE_FAILD, error } }
}

function updateFilter(payload) {
    return { type: DONHANGSANPHAM_UPDATE_FILTER, data: payload }
}

function listNoLimit() {
    return (dispatch, getState) => {
      const { account } = getState()
      dispatch(AppAction.appLoading(true));
      DonhangsanphamService.listNoLimit().then((rs) => {
        dispatch(success({
            items: rs.data.values,
            total: rs.data.count
        }));
      }).catch((error) => {
        dispatch(failure(error));
      }).finally(() => {
        dispatch(AppAction.appLoading(false));
      })
    };
    function success(data) { return { type: DONHANGSANPHAM_LIST_SUCCESS, data } }
    function failure(error) { return { type: DONHANGSANPHAM_LIST_FAILD, error } }
  }

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        DonhangsanphamService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: DONHANGSANPHAM_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: DONHANGSANPHAM_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { donhangsanpham } = getState()
        dispatch(AppAction.appLoading(true));
        DonhangsanphamService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...donhangsanpham.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: DONHANGSANPHAM_LIST_SUCCESS, data } }
    function failure(error) { return { type: DONHANGSANPHAM_LIST_FAILD, error } }
}

function saveDataUpload(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0;
        let errorRows = {};
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            DonhangsanphamService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                // if (count === payload.length) {
                //     dispatch(success(rs));
                //     dispatch(AppAction.appLoading(false));
                // }

                if (rs.data.errorRows) {
                    Object.entries(rs.data.errorRows).forEach(([key, value]) => {
                        errorRows[i * 200 + Number(key)] = value;
                    });
                }

                if (i + 200 >= payload.length) {
                    dispatch(handleErrors(errorRows));
                    dispatch(success(rs));
                    dispatch(DonhangsanphamAction.list());
                    alert("Tải file thành công: \"" + payload[0].ten_file_upload + "\" (" + count + " bản ghi)");
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function handleErrors(data) { return { type: DONHANGSANPHAM_HANDLE_IMPORT_ERRORS, data } }
    function success(data) { return { type: DONHANGSANPHAM_SAVE_SUCCESS, data } }
    function failure(error) { return { type: DONHANGSANPHAM_SAVE_FAILD, error } }
}

function findPackage(ten_goi_cuoc) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            DonhangsanphamService.findPackage(ten_goi_cuoc)
            .then(response => {
                // Handle the successful response
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                reject(error); // Reject the promise with the error
            });
        });
    };
}

function listExport() {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const { donhangsanpham } = getState();

            const { filter } = donhangsanpham;

            // Perform your asynchronous operation (e.g., API call)
            DonhangsanphamService.listExport(filter)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    }
    function success(data) { return { type: DONHANGSANPHAM_LIST_EXPORT_SUCCESS, data } }
    function failure(error) { return { type: DONHANGSANPHAM_LIST_EXPORT_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        const { donhangsanpham } = getState();
        dispatch(AppAction.appLoading(true));

        const { filter } = donhangsanpham;
        const page = filter.page;
        const limit = filter.limit;

        return new Promise((resolve, reject) => {
            DonhangsanphamService.findAll(filter.page, filter.limit, filter).then((rs) => {
                if (!!filter && filter.page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count,
                    }));
                } else {
                    const oldItems = donhangsanpham.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: DONHANGSANPHAM_LIST_SUCCESS, data } }
    function failure(error) { return { type: DONHANGSANPHAM_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: DONHANGSANPHAM_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            DonhangsanphamService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(DonhangsanphamAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: DONHANGSANPHAM_SAVE_SUCCESS, data } }
    function failure(error) { return { type: DONHANGSANPHAM_SAVE_FAILD, error } }
}

function create(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        DonhangsanphamService.create(payload).then((rs) => {
            dispatch(success(rs));
            dispatch(DonhangsanphamAction.list())
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể tạo, có thể do trùng số điện thoại!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: DONHANGSANPHAM_CREATE_SUCCESS, data } }
    function failure(error) { return { type: DONHANGSANPHAM_CREATE_FAILD, error } }
}

function update(id, payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        DonhangsanphamService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(DonhangsanphamAction.list())
            if (typeof rs.msg !== 'undefined' && rs.msg) {
                alert(rs.msg)
            }
        }).catch((error) => {
            dispatch(failure(error));
            alert("Lỗi không xác định!")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: DONHANGSANPHAM_CREATE_SUCCESS, data } }
    function failure(error) { return { type: DONHANGSANPHAM_CREATE_FAILD, error } }
}

function del(id) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        DonhangsanphamService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(DonhangsanphamAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: DONHANGSANPHAM_DEL_SUCCESS, data } }
    function failure(error) { return { type: DONHANGSANPHAM_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        DonhangsanphamService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: DONHANGSANPHAM_ONE_SUCCESS, data } }
    function failure(error) { return { type: DONHANGSANPHAM_ONE_FAILD, error } }
}

function assign(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        DonhangsanphamService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(DonhangsanphamAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}

function history(payload) {
    return (dispatch, getState) => {
        const { donhangsanpham } = getState()
        dispatch(AppAction.appLoading(true));
        DonhangsanphamService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...donhangsanpham.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: DONHANGSANPHAM_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: DONHANGSANPHAM_HISTORY_LIST_FAILD, error } }
}

function sendDonhangsanpham(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        DonhangsanphamService.sendDonhangsanpham(payload).then((rs) => {
            dispatch(success(rs));
            alert("Đặt hàng thành công!");
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể đặt sim này, có thể do hiện tại sim này đã bán. Bạn vui lòng chọn sim khác. Xin cảm ơn!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: DONHANGSANPHAM_DONHANGSANPHAM_SUCCESS, data } }
    function failure(error) { return { type: DONHANGSANPHAM_DONHANGSANPHAM_FAILD, error } }
}